function CalendarCardPaging(widgetId) {
    var take = $('#paging-take-' + widgetId);
    var skip = $('#paging-skip-' + widgetId);
    var guidList = $('#paging-guid-list-' + widgetId);
    var showDescriptions = $('#paging-show-descriptions-' + widgetId);
    var view = $('#paging-view-' + widgetId);
    var totalCount = $('#totalRecordCountSpan-' + widgetId);
    var resultsContainer = $('#cal-card-listing-' + widgetId);

    $.ajax({
        url: "/geteventresults",
        data: {
            viewName: view.val(),
            eventGuidStr: guidList.val(),
            skip: parseInt(skip.val()),
            itemsPerPage: parseInt(take.val()),
            showDescriptions: showDescriptions.val()
        },
        contentType: 'application/x-www-form-urlencoded',
        method: "POST",
        success: function (result) {
            //Append new results. Update counters.
            resultsContainer.append(result);

            var skipInt = parseInt(skip.val());
            var takeInt = parseInt(take.val());
            var totalCountInt = parseInt(totalCount.text());
            skipInt = skipInt + 1;
            skip.val(skipInt);

            //We are at the end of the results. Hide load more.
            if (skipInt * takeInt >= totalCountInt) {
                $("#loadedCardContent-" + widgetId + " #loadMoreCalendarCardResults-" + widgetId).hide();
                $("#currentDisplayCountSpan-" + widgetId).html(totalCountInt);
            } else {
                $("#currentDisplayCountSpan-" + widgetId).html(skipInt * takeInt);
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            alert("Status: " + textStatus); alert("Error: " + errorThrown);
        }
    });
}